// Third-party
import React from 'react';
import moment from 'moment';

// Types
import Locale from '@/types/locale';
import ComparisonItem from '@/types/comparison-item';

// Utils
import { FormattedMessage, formatLocalizedString, formatMessageWithLocale } from '@/utils/i18n';
import { truncateString } from '@/utils/objects';
import { COMPARISON_ITEM_TYPES } from '@/utils/constants';

interface Props {
  items?: ComparisonItem[];
  locale?: Locale;
  disclaimerKey?: string;
  sectionKey?: string;
}

export default function SinceInceptionDateDisclaimer({ disclaimerKey, items, locale, sectionKey }: Props) {
  let index = 0;
  const getElementDisclaimer = (item: ComparisonItem) => {
    const {
      type,
      dates: { inception },
      name: itemName,
      holdings,
    } = item;
    const { BENCHMARK, PORTFOLIO, GROUP } = COMPARISON_ITEM_TYPES;

    if (type === BENCHMARK || !inception) {
      return null;
    }

    const date = moment.utc(inception).format(formatMessageWithLocale('Common.DateFormats.Short', locale));
    let name = truncateString(formatLocalizedString(itemName), 40);

    if (type !== PORTFOLIO && type !== GROUP && holdings[0].symbol) {
      name = holdings[0].symbol;
    }

    index++;

    return (
      <div id={`numbered-disclaimer-${disclaimerKey}-${sectionKey}-${index}`} role="note" style={{ display: 'block', fontWeight: '400' }}>
        <sup className="disclaimer-marker">{index}</sup>
        <FormattedMessage id="Disclaimers.SinceInceptionDate.Prefix" locale={locale} />
        <strong>{name}</strong>
        <FormattedMessage id="Disclaimers.SinceInceptionDate.Suffix" values={{ date }} locale={locale} />
      </div>
    );
  };

  return (
    <span className="disclaimer">
      {items?.map(i => (
        <span key={i._id} className="item-name font-weight-normal" data-private data-dd-privacy="mask">
          {getElementDisclaimer(i)}
        </span>
      ))}
    </span>
  );
}
